(function (base, $, undefined) {
  'use strict';

  /* Sticky header */
  var stickyHeaderInit = function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.sticky-header').addClass('stick');
        //$('body').css('paddingTop', 110);
      }
      else {
        $('.sticky-header').removeClass('stick');
        //$('body').css('paddingTop', 0);
      }
    });
  };

  /* Carousels */
  var owlCarouselInit = function () {
    var loop = $('.carousel > div').length > 1 ? true : false;
    var $gallery = $('.carousel');

    $gallery.owlCarousel({
      items: 1,
      center: true,
      loop: loop,
      dots: false,
      smartSpeed: 1300,
      nav: loop
    });

    var $caseStudies = $('.case-studies');
    $caseStudies.owlCarousel({
      items: 1,
      center: true,
      loop: loop,
      dots: true,
      nav: true,
      smartSpeed: 1300
    });

    $(window).resize(function () { $('.owl-carousel').trigger('refresh.owl.carousel'); });
  };

  /*  add a  max length to expiry date*/
  var focusNext = function () {
    $('.donate-form .expiry-date').keyup(function () {
      if ($(this).val().length == $(this).attr("maxlength")) {
        $(this).nextUntil().focus();
      }
    });
  };

  /* make postcode uppercase */
  $("#Postcode").keyup(function () {
    var ucase = $(this).val().toUpperCase()
    $(this).val(ucase);
  });

  /* Countdown on hero */
  var countdown = function () {
    var second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

    var countdownDate = $('body').find('.countdown').data('date');
    //console.log(countdownDate);
    var countDown = new Date(countdownDate).getTime(),
      x = setInterval(function () {

        var now = new Date().getTime(),
          distance = countDown - now;

        $('body').find('.countdown-days').html(Math.floor(distance / (day)));
        $('body').find('.countdown-hours').html(Math.floor((distance % (day)) / (hour)));
        $('body').find('.countdown-minutes').html(Math.floor((distance % (hour)) / (minute)));
        $('body').find('.countdown-seconds').html(Math.floor((distance % (minute)) / second));

        //do something later when date is reached
        //if (distance < 0) {
        //  clearInterval(x);
        //  'IT'S MY BIRTHDAY!;
        //}

      }, second)
  };

  /* Original Convert giftaid calculation */
  var convert = function () {

    var $amount = $('#Amount');
    var originalInput = $amount.val();
    var $convertBox = $('.convert')

    // Do the gift aid calculation and output to .convert
    function convert(originalInput) {
      var convertedValue = originalInput + (originalInput / 4);
      $convertBox.html(convertedValue.toFixed(2));
      //console.log(convertedValue);
    };

    // On Input or Change => do the gift aid conversion

    $amount.on('input change', function () {
      var thisValue = Number($(this).val());
      convert(thisValue);
    });

    // On button click => do conversion
    convert(Number(originalInput));

    /* start animation on giftaid when button is pressed */


  };

  var countUp = function () {

    var $amount = $('#Amount');
    //console.log($amount.val())

    $('.convert').each(function () {
      $(this).prop('Counter', $amount.val()).animate({
        Counter: $(this).text()
      }, {
        duration: 6000,
        easing: 'swing',
        step: function (now) {
          $(this).text(now.toFixed(2));
        }
        // complete:function(now){
        //     $(this).text(now.toFixed(2));
        // }
      });
    });

  }

  /* Show impact messages depending on price of single item and range of values  */
  var impactValue = function () {
    /* Debounce */
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    };
    /*  get the amount from input */
    var amount = parseFloat($('#Amount').val());
    /*  Show impact message */
    $('.impact-message').each(function () {
      var start = parseFloat($(this).attr('data-start'));
      var end = parseFloat($(this).attr('data-end'));

      if (amount >= start && amount <= end) {
        $('.impact-message').removeClass('active');
        $('.donation-impact').addClass('grey');
        $(this).addClass('active');

        var impactCost = parseFloat($(this).find('.impact-cost').attr('data-impact'));
        var impact = (amount / impactCost);

        $('.impact-cost').text(impact.toFixed(0));
      }
    });

    var changeText = function () {
      if ($('.frequency').length) {
        $(".frequency").text('Each ' + $('input[name=PaymentSchedule]:checked').val());
        $(".frequency").text(function () {
          return $(this).text().replace("Monthly", "month");
        });
        $(".frequency").text(function () {
          return $(this).text().replace("Quarterly", "quarter");
        });
        $(".frequency").text(function () {
          return $(this).text().replace("Annually", "year");
        });
      }
    }
    /* display input value on front end  */
    $(".output-value").text($('input#Amount').val());

    changeText();


    /* update amount when input is updated  */
    $('#Amount').on('change keyup', debounce(changeFunction, 500));

    $('input[name=PaymentSchedule]').on('change keyup', debounce(changeFunction, 500));


    /*  Show impact message on load - if a value is already entered */
    function changeFunction() {
      var amount = parseFloat($('#Amount').val());

      $('.impact-message').each(function () {

        var start = parseFloat($(this).attr('data-start'));
        var end = parseFloat($(this).attr('data-end'));

        if (amount >= start && amount <= end) {
          $('.impact-message').removeClass('active');
          $(this).addClass('active');
          $('.donation-impact').addClass('grey');

          var impactCost = parseFloat($(this).find('.impact-cost').attr('data-impact'));
          var impact = (amount / impactCost);
          $('.impact-cost').text(impact.toFixed(0));
        }

      });
      /* display input value on front end  */
      $(".output-value").text($('input#Amount').val());

      changeText();

    };

    /* Change input width depending on characters entered - (center aligned input on design)  */
    if ($('#stripe-donation-form #Amount, #DirectDebitForm #Amount').length) {
      var input = document.querySelector('#stripe-donation-form #Amount, #DirectDebitForm #Amount'); // get the input element
      input.addEventListener('#stripe-donation-form #Amount, #DirectDebitForm #Amount', resizeInput); // bind the "resizeInput" callback on "input" event
      resizeInput.call(input); // immediately call the function

      function resizeInput() {
        this.style.width = this.value.length + "ch";
      }
      $('#stripe-donation-form #Amount, #DirectDebitForm #Amount').on('change', function () {
        this.style.width = this.value.length + 2.8 + "ch";
      });
      $('#stripe-donation-form #Amount, #DirectDebitForm #Amount').keyup(function () {
        this.style.width = this.value.length + 2.8 + "ch";
      });
    }
  };

  /*  wrap iframe  */
  var responsiveIframe = function () {
    $('iframe[src*="youtube"],iframe[src*="vimeo"]').wrap('<div class="responsive-frame"></div>');
  };

  /*  Slide Effect for form slides */
  var stripeForm = function () {
    var currentSlide = 0,
      $slideContainer = $('.slide-container'),
      $slide = $('.slide'),
      slideCount = $slide.length,
      animationTime = 300;

    function setSlideDimensions() {
      var windowWidth = $(window).width();
      var windowHeight = $('.slide').eq(currentSlide).height();
      $slideContainer.width(windowWidth * slideCount);
      //$slideContainer.height(windowHeight);
      $slide.width(windowWidth);
    }

    function generatePagination() {
      var $pagination = $('.pagination');

      for (var i = 0; i < slideCount; i++) {
        var $indicator = $('<div>').addClass('indicator'),
          $progressBarContainer = $('<div>').addClass('progress-bar-container'),
          $progressBar = $('<div>').addClass('progress-bar'),
          indicatorTagText = $slide.eq(i).attr('data-tag'),
          $tag = $('<div>').addClass('tag').text(indicatorTagText);
        $indicator.append($tag);
        $progressBarContainer.append($progressBar);
        $pagination.append($indicator).append($progressBarContainer);

      }
      $pagination.find('.indicator').eq(0).addClass('active');

    }


    function goToNextSlide() {

      if ($('#FirstName').val() && $('#LastName').val() && $('#Amount').val()) {
        var form = $('#stripe-donation-form');
        var card = $('#Relationship').val() === 'My gift is in lieu of presents,';
        var rk = $('#RandomKey').val();
        var data = 'action=set_donation_session&one-off=1&card=' + card + '&RandomKey=' + rk + '&' + form.serialize();

        $.ajax({
          url: '/wp-admin/admin-ajax.php',
          data: data,
          type: 'POST',
          success: function (response) {

          }
        });
      }

      if (currentSlide >= slideCount - 1) return;
      if ($('.slide').eq(currentSlide).hasClass('details')) {
        //console.log( "Valid: " + form.valid() );
        if (!$("#stripe-donation-form").valid()) {
          // do stuff if form is not valid
          return;
        }
      }
      var windowWidth = $(window).width();
      //var windowHeight = $('.slide').eq(currentSlide + 1).height();
      if ($('.slide').eq(currentSlide + 1).hasClass('gift')) {
        countUp();
      }
      if ($('.slide').eq(currentSlide + 1).hasClass('last')) {
        var $email = jQuery('#Email').val();
        $('#SummaryAmount').html('<p>You are donating £' + $('#Amount').val() + '</p>');
        if (typeof GeneratePaymentRequestBtn == 'function' && $email !== '' && !jQuery('#payment-request-button').hasClass('StripeElement')) {
          GeneratePaymentRequestBtn();
        }
      }
      if ($('.slide').eq(currentSlide).hasClass('gift')) {
        $('.convert').stop(true, true);
      }

      currentSlide++;
      $slideContainer.animate({
        //left: -(windowWidth * currentSlide),
        //height: windowHeight
      });
      setActiveIndicator();
      setActiveSlide();
      setActiviaSlide();
      setFirstSlide();
      setActiveLast();
      setLastSlide();
      validateForm();
      setSlideDimensions();

      $('.progress-bar').eq(currentSlide - 1).animate({
        width: '100%'
      }, animationTime);

    }

    function goToPreviousSlide() {
      if (currentSlide <= 0) return;
      var windowWidth = $(window).width();
      var windowHeight = $('.slide').eq(currentSlide - 1).height();
      if ($('.slide').eq(currentSlide - 1).hasClass('gift')) {
        countUp();
      }
      if ($('.slide').eq(currentSlide).hasClass('gift')) {
        $('.convert').stop(true, true);
      }
      if ($('.slide').eq(currentSlide).hasClass('last')) {
        if (typeof elements !== 'undefined') {
          elements.getElement('paymentRequestButton').destroy();
        }
      }

      currentSlide--;
      $slideContainer.animate({
        //left: -(windowWidth * currentSlide),
        //height: windowHeight
      }, animationTime);
      setActiveIndicator();
      setActiveSlide();
      setActiviaSlide();
      setFirstSlide();
      setActiveLast();
      setLastSlide();
      validateForm();

      $('.progress-bar').eq(currentSlide).animate({
        width: '0%'
      }, animationTime);
    }

    function postitionSlides() {
      var windowWidth = $(window).width();
      //var windowHeight = $('.slide').eq(currentSlide).height();
      setSlideDimensions();
      $slideContainer.css({
        //left: -(windowWidth * currentSlide),
        //height: windowHeight
      }, animationTime);
    }

    function setActiveIndicator() {
      var $indicator = $('.indicator');
      $indicator.removeClass('active').removeClass('complete');
      $indicator.eq(currentSlide).addClass('active');
      for (var i = 0; i < currentSlide; i++) {
        $indicator.eq(i).addClass('complete');
      }
    }

    function setActiveSlide() {
      var $slideindicator = $('.slide');

      $slideindicator.removeClass('active').removeClass('complete');
      $slideindicator.eq(currentSlide).addClass('active');


      for (var i = 0; i < currentSlide; i++) {
        $slideindicator.eq(i).addClass('complete');
      }
    }
    /*  add extra class to first slide - so we can hide back button*/
    function setActiviaSlide() {
      var $slideindicatored = $('.first');

      if ($slideindicatored.hasClass('active', 'complete')) {
        $slideindicatored.eq(currentSlide).addClass('activated');
      }

      else {
        $slideindicatored.removeClass('activated');
      }
    }
    /*  add extra class to last slide - so we can hide back button*/
    function setActiveLast() {
      var $slideindicat = $('.last');

      if ($slideindicat.hasClass('active', 'complete')) {
        $slideindicat.addClass('activated');
      }

      else {
        $slideindicat.removeClass('activated');
      }
    }
    /*  hide back button on first slide*/
    function setFirstSlide() {
      if ($('.first.activated').length) {
        $('.previous').addClass('hidden');
      }
      else {
        $('.previous').removeClass('hidden');
      }
    }
    /*  hide next button on last slide*/
    function setLastSlide() {
      if ($('.last.activated').length) {
        $('.next').addClass('hidden');
        $('#submitButton').removeClass('hidden');

      }
      else {
        $('.next').removeClass('hidden');
        $('#DirectDebitForm #submitButton , #stripe-donation-form #submitButton').addClass('hidden');
      }
    }
    /* Move submit button to button container*/
    function moveSubmit() {
      $('#submitButton').appendTo('.button-container');
    }
    /* Form Validation */
    function validateForm() {
      if ($('#stripe-donation-form, #DirectDebitForm').length) {
        jQuery.validator.setDefaults({
          debug: false,
          success: "valid"
        });
        var form = $("#stripe-donation-form , #DirectDebitForm");
        form.validate();
      }
    }

    // if ( $(window).width() > 500 ) {
    moveSubmit();
    setFirstSlide();
    setActiveLast();
    setLastSlide();
    setSlideDimensions();



    $(window).resize(postitionSlides);
    $('.slide').on('change', postitionSlides);
    $('.next').on('click', goToNextSlide);
    $('.previous').on('click', goToPreviousSlide);

    var $slides = ['.slide.first', '.slide.gift', '.slide.details', '.slide.last'];
    if ($('.page-template-template-gocardless').length) {
      $slides = ['.slide.first', '.slide.gift', '.slide.last'];
    }
    for (var $i = 0; $i < $slide.length; $i++) {
      document.querySelector($slides[$i]).addEventListener("keydown", function (event) {
        //console.log(event.which);
        if (event.which == 9 && event.target.id == 'Comment') {
          event.preventDefault();
          goToNextSlide();
          setTimeout(function () {
            document.getElementById('GiftAid').focus();
          }, 310);
        }
        if (event.which == 9 && event.target.id == 'GiftAid') {
          event.preventDefault();
          goToNextSlide();
          setTimeout(function () {
            document.getElementById('Title').focus();
          }, 310);
        }
        if (event.which == 9 && event.target.id == 'contactpost') {
          event.preventDefault();
          $('#SummaryAmount').html('<p>You are donating £' + $('#Amount').val() + '</p>');
          goToNextSlide();
          if (typeof GeneratePaymentRequestBtn == 'function') {
            GeneratePaymentRequestBtn();
          }
          setTimeout(function () {
            document.getElementById('payment-request-button').focus();
          }, 310);
        }
      });
    };
    generatePagination();
    validateForm();

    if ($('.stripe-donation-form').length) {
      var elem = document.forms['stripe-donation-form'].elements;
      for (i = 0; i < elem.length; i++) {
        elem[i].tabIndex = 99 + i;
      }
    }
  };

  /* Show popup feature */
  var showPop = function () {

    if ($('.pop-button').length) {
      var $poplink = $('.pop-button'),
        $popwrapper = $('#content1');

      $poplink.click(function (e) {
        e.preventDefault();
        $poplink.toggleClass('active');
        $popwrapper.toggleClass('active');
      });
    }
  };

  var backToTop = function () {
    if ($('.back-to-top').length) {
      var target = $('.back-to-top');

      $(document).on('scroll', function () {
        var top = $(document).scrollTop();
        if (top > 500 && !target.hasClass('active')) {
          target.addClass('active');
        } else if (top < 501 && target.hasClass('active')) {
          target.removeClass('active');
        }
      });

      target.on('click', function () {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      });
    }
  }

  var modalNews = function () {

    var $modalTrigger = $('.modal-button'),
      $modalContent = $('.modal-content'),
      $modalWrapper = $('.modal-wrapper'),
      $modalClose = $('.close-modal'),
      $modalTitle = $('#modalTitle'),
    $mainContent = $('.main-content');

    function setModalButton() {
      $modalTrigger.on("click", function (e) {
        $mainContent.attr('aria-hidden', 'true');
        $modalWrapper.attr('aria-hidden', 'false');
        $modalWrapper.css('display', 'flex');
        $modalTitle.focus();
        deflectFocus();
        $('#contra-newsletter, .news-desc').show();
        $('.thank-you').hide();
      });
    };

    function setModalClose() {
      $modalClose.on("click", function (e) {
        e.preventDefault();
        $modalWrapper.attr('aria-hidden', 'true');
        $modalWrapper.css('display', 'none');
        $mainContent.attr('aria-hidden', 'false');
        $modalTrigger.focus();
        $mainContent.off('.modalOpen');
      });
    };

    function deflectFocus() {
      $mainContent.on('focusin.modalOpen', function (e) {
        $modalClose.focus();
      });
    };

    function ValidateForm() {
      $('#contra-newsletter').validate().settings.ignore = ':disabled,:hidden';
      return $('#contra-newsletter').valid();
    };

    function EnableSubmitButton() {
      $('#submitNewsletter').removeAttr('disabled');
      $('#submitNewsletter').html('Submit');
    };

    function DisableSubmitButton() {
      $('#submitNewsletter').html('Processing...');
      $('#submitNewsletter').attr('disabled', 'disabled');
    };

    function Process() {
      var email = jQuery("#Email").val();
      var title = jQuery("#Title").val();
      var firstName =
        jQuery("#FirstName").length > 0 ? jQuery("#FirstName").val() : "";
      var lastName =
        jQuery("#LastName").length > 0 ? jQuery("#LastName").val() : "";
      var keepInTouch = jQuery("#contactemail").is(":checked")
        ? jQuery("#contactemail").val()
        : 0;
      var siteKey = jQuery("#ReCaptchaSiteKey").val();
      var action = jQuery("#ReCaptchaAction").val();

      try {
        grecaptcha.ready(function () {
          grecaptcha
            .execute(siteKey, {
              action: action
            })
            .then(function (token) {
              jQuery
                .ajax({
                  dataType: "json",
                  url: "/wp-json/newsletter/subscribe",
                  method: "POST",
                  type: "POST",
                  data: {
                    title: title,
                    keepInTouch: keepInTouch,
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    token: token
                  }
                })
                .done(function (data) {
                  if (data.OK) {
                    jQuery("#submitNewsletter").attr(
                      "data-secret",
                      data.RequestData
                    );
                    $("#contra-newsletter, .news-desc").hide();
                    $(".thank-you").show();
                    EnableSubmitButton();
                    var requestData = data.RequestData;
                    return requestData;
                  }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                  console.log("Exception in Process ");
                });
            });
        });
      } catch (e) {
        console.log("Exception in Process " + e);
      }
    }

    function downloadURI(uri, name) {
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      link = null;
    }

    $('.convert-now .convert-btn').on('click', function (e) {
      e.preventDefault();
      $('.convert-now .thankyou-popup').addClass('active');
      $('body').addClass('popup');
    });

    $('.download .download-card').on('click', function (e) {
      e.preventDefault();
      $('.download .thankyou-popup').addClass('active');
      $('body').addClass('popup');
    });

    $('.thankyou-popup .overlay, .thankyou-popup__close').on('click', function () {
      $('.thankyou-popup').removeClass('active');
      $('.body').removeClass('popup');
    });

    $('.download form').on('submit', function (e) {
      e.preventDefault();
      var FromName = $(this).find('#FromName') ? btoa($(this).find('#FromName').val()) : '';
      var name = $(this).find('#thankyou-name') ? btoa($(this).find('#thankyou-name').val()) : '';
      var amount = $(this).find('#thankyou-amount') ? btoa($(this).find('#thankyou-amount').val()) : '';
      var url = '/donate/your-pdf/?doname=' + name + '&amount=' + amount + '&fromname=' + FromName;
      downloadURI(url, "Thank you");
    });

    $('.convert-now form').on('submit', function (e) {
      e.preventDefault();
      PostPayment(e.target);
    });

    function GetBaseServiceUrl() {
      return "https://api.donorfy.com/api/gocardless/directdebitpayment";
    }

    function PostPayment(form) {

      jQuery.ajax({
        dataType: 'json',
        url: GetBaseServiceUrl(),
        data: $(form).serialize(),
        method: 'POST',
        type: 'POST'
      }).done(function (data) {
        if (data.OK) {
          var redirectUrl = data.RedirectUrl;
          location.href = redirectUrl;
        }

      }).fail(function (jqXHR, textStatus, errorThrown) {
        console.error(GetErrorArray(jqXHR));
      });

    }

    function GetErrorArray(jqXHR) {

      var errors = [];

      var response = JSON.parse(jqXHR.responseText);

      if (response.ModelState) {
        for (var key in response.ModelState) {
          errors.push(response.ModelState[key]);
        }
      } else if (response.Message) {
        errors.push(response.Message);
      } else {
        errors.push('An unexpected error occurred.');
      }

      return errors;
    }

    function initForm() {
      var submitButton = document.getElementById('submitNewsletter');
      if (($('#submitNewsletter')).length) {
        submitButton.addEventListener('click',
          function (ev) {
            DisableSubmitButton();
            if (ValidateForm()) {
              try {
                Process();
              } catch (e) {
                EnableSubmitButton();
                console.log('Exception  ' + e);
                ev.preventDefault();
                return false;
              }

            } else {
              EnableSubmitButton();
            }
            ev.preventDefault();
            return false;
          });
      }
    }

    setModalButton();
    setModalClose();
    initForm();
  };

  var quickLinks = function () {

    if ($('.jump__to').length) {
      // minimal quantity of headings make quick links to be displayed
      var minQuantity = 1;
      var quickLinks = document.createElement('div');
      quickLinks.classList.add('jump__to--wrapper');
      var linksList = document.createElement('ul');
      quickLinks.appendChild(linksList);

      // find h2 headings
      var h2 = $('.page-template-template-pillar main').find('.pillar--section div.jump--to');

      if (h2.length >= minQuantity) {
        h2.each(function () {
          var words = $(this).text();
          var wordsForID = $(this).text().replace(/[^0-9a-z]/gi, '');

          //console.log(words);
          $(this).attr('id', wordsForID);
          var list = document.createElement('li');
          list.className = 'jump__to--item';
          linksList.appendChild(list);
          var el = document.createElement('a');
          el.className = 'jump__to--link';
          el.href = '#' + wordsForID;
          el.text = words;
          list.appendChild(el);
        });


        //console.log(h2);
        $('.jump__to').append(quickLinks);
      }

      $('.sidebar-2').stick_in_parent({
        offset_top: 120
      });

      var addButton = $('.page-template-template-pillar main');
      addButton.append('<div class="open-jump-menu"><span></span><span></span><span></span></div>');
      var jumpMenuButton = addButton.find('.open-jump-menu');

      if (jumpMenuButton.length) {
        jumpMenuButton.on('click', function (ev) {
          ev.preventDefault();
          $('.sidebar-2').toggleClass('open');
          addButton.toggleClass('active');
          $('.sidebar-2').trigger("sticky_kit:detach");
        })
      };
      $('.jump__to a').on('click', function (ev) {
        ev.preventDefault();
        $('.sidebar-2').removeClass('open');
        addButton.removeClass('active');
      });

    }
  };

  var linkScroll = function () {
    $('a.jump__to--link[href^="#"]')
      .on('click', function (event) {
        event.preventDefault();
        var target = $(this.getAttribute('href'));
        if (target.length) {
          event.preventDefault();
          $('html, body').stop().animate({
            scrollTop: target.offset().top - 200
          }, 1000);
        }
      });
  };

  var trackForm = function () {
    var form = document.getElementById("DirectDebitForm");
    if (form) {
      form.addEventListener("submit", onFormSubmit);
      function onFormSubmit(event) {
        // Your form handling code here
        var orderVal = jQuery('#Amount').val();
        analyticsPush(orderVal);

        zarazTracking(orderVal);

        googleTracking(orderVal);
      }
    }
  };

  function zarazTracking(orderVal) {
    try {
      zaraz.ecommerce('Order Completed', {
        checkout_id: Math.floor((Math.random() * 1000000) + 1) + orderVal,
        order_id: Math.floor((Math.random() * 1000000) + 1) + orderVal,
        total: orderVal,
        revenue: orderVal,
        currency: 'gbp',
        products: [
          {
            product_id: Math.floor((Math.random() * 1000000) + 1) + orderVal,
            sku: Math.floor((Math.random() * 1000000) + 1) + orderVal,
            name: 'Regular Donation',
            price: orderVal,
            quantity: 1,
            category: 'regular',
          },
        ],
      });
      console.log('zaraz ecommerce success');

      zaraz.track("regularDonation", { value: orderVal, currency: "GBP" });
      console.log('zaraz tracking success');
    } catch (error) {
      console.log('zaraz tracking failed')
    }
  }

  function linkedinTracking(orderVal) {
    window.lintrk('track', { conversion_id: 15000346 });
  }

  function googleTracking(orderVal) {
    try {
      gtag('event', 'conversion', {
        'send_to': 'AW-11029487667/0iJcCLGOuesYELPAoosp',
        'value': orderVal,
        'currency': 'GBP',
        'transaction_id': Math.floor((Math.random() * 1000000) + 1) + orderVal,
      });

      gtag('event', 'conversion', {
        'send_to': 'AW-586376080/jah5CJK0x-sYEJDHzZcC',
        'value': orderVal,
        'currency': 'GBP',
        'transaction_id': Math.floor((Math.random() * 1000000) + 1) + orderVal,
      });
    } catch (error) {
      console.log('gtag tracking failed')
    }
  }

  function analyticsPush(orderVal) {
    try {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'donation',
        'transactionId': Math.floor((Math.random() * 1000000) + 1) + '-' + orderVal,
        'transactionAffiliation': 'St Martin in the Fields',
        'transactionTotal': orderVal,
        'transactionProducts': [{
          'sku': 'RD',
          'name': 'Donation',
          'category': 'Regular',
          'price': orderVal,
          'quantity': 1
        }]
      });
    } catch (error) {
      console.log('datalayer tracking failed')
    }
  }

  function getUrlParams(url) {
    var params = {};
    var queryString = url.split('?')[1];
    var urlParams = new URLSearchParams(queryString);

    urlParams.forEach(function(value, key) {
      params[key] = value;
    });

    return params;
  }

  function getUTMParams() {
    var storedParams = localStorage.getItem('utmParams');
    if (storedParams) {
      return JSON.parse(storedParams);
    } else {
      return null; // Return null if no UTM parameters are stored
    }
  }

  var storeUTMParams = function () {
    var urlParams = getUrlParams(window.location.href);
    var utmParams = {};
    // Check if there are any UTM parameters in the URL
    if (urlParams.hasOwnProperty('utm_source')) {
      utmParams['utm_source'] = urlParams['utm_source'];
    }
    if (urlParams.hasOwnProperty('utm_medium')) {
      utmParams['utm_medium'] = urlParams['utm_medium'];
    }
    if (urlParams.hasOwnProperty('utm_campaign')) {
      utmParams['utm_campaign'] = urlParams['utm_campaign'];
    }
    if (urlParams.hasOwnProperty('utm_term')) {
      utmParams['utm_term'] = urlParams['utm_term'];
    }
    if (urlParams.hasOwnProperty('utm_content')) {
      utmParams['utm_content'] = urlParams['utm_content'];
    }

    // Store UTM parameters in local storage
    localStorage.setItem('utmParams', JSON.stringify(utmParams));
  }

  base.init = function () {
    stickyHeaderInit();
    owlCarouselInit();
    focusNext();
    countdown();
    convert();
    impactValue();
    responsiveIframe();
    stripeForm();
    showPop();
    backToTop();
    modalNews();
    quickLinks();
    linkScroll();
    trackForm();
    storeUTMParams();

    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
  };

})(window.base = window.base || {}, jQuery);

jQuery(document).ready(function () {
  window.base.init();

  $('#menu-item-7589').on('click', function (e) {
    e.preventDefault();
    if ($('.volunteer-container').length) {
      $('.volunteer-container').addClass('pop');
      setTimeout(function () {
        $('.volunteer-container').css({ width: '60vw', height: '60vh' }).promise().done(function () {
          setTimeout(function () {
            $('.volunteer-container > div').css({ opacity: 1, visibility: 'visible' });
            $('#wpcf7-f163-p39-o1 input[type="email"]').focus();
          }, 300);
        });
      }, 200);
    } else {
      window.location = $(this).find('a').attr('href');
    }
  });

  $(document).on('click', function (e) {
    var elem = $(e.target).parent().parent().attr('id');
    var formID = $(e.target).parents('#wpcf7-f163-p39-o1').attr('id');
    if (elem !== 'menu-item-7589' && formID !== 'wpcf7-f163-p39-o1') {
      $('.volunteer-container').removeClass('pop');
      $('.volunteer-container').removeAttr('style');
    }
  });

  $(window).on('resize', function () {
    //equalHeightsModal();
    if ($(window).width() < 500) {
      //$('#stripe-donation-form .pagination-container').hide();
      //$('.slide-container').addClass('mobile');
      $('#submitButton').appendTo('.slide.last .sized-container .payment-details');

    } else {
      //$('#stripe-donation-form .pagination-container').show();
      //$('.slide-container').removeClass('mobile');
      $('#submitButton').appendTo('.button-container');
    }
    //console.log($(window).width());
  });
});

$(document).ready(function () {
  $('#Relationship').on('change', function () {
    var relationship = $(this).val();
    $('#Comment').val(relationship + '\n');
  });

});

$('#tab2-hero').on('click', function () {
  $('#tab1-hero').toggleClass('active');
});

$('#tab1-hero').on('click', function () {
  $(this).removeClass('active');
});

$('#tab2-landing').on('click', function () {
  $('#tab1-landing').toggleClass('active');
});

$('#tab1-landing').on('click', function () {
  $(this).removeClass('active');
});

$('#tab-flex-2').on('click', function () {
  $('#tab-flex-1').toggleClass('active');
});

$('#tab-flex-1').on('click', function () {
  $(this).removeClass('active');
});

if ($('.box-video iframe').length) {
  $('.box-video').each(function () {
    var src = $('iframe', this)[0].src;
    if (src.includes("wistia.net")) {
      $(this).addClass('open');
    }
    $(this).fadeIn();
  });
  $('.box-video').on('click', function () {
    $('iframe', this)[0].src += "&amp;autoplay=1";
    $(this).addClass('open');
  });
}
var h1size = 32;
$('h1').filter(function () {
  return $(this).text().length > h1size;
}).addClass('is-long');